import { RailExecutor } from "./RailExecutor";
import { RailPart } from "./RailPart";
import { defaultRailPartOptions } from "./RailPartOptions";

export class SARABSExecutor extends RailExecutor {
  constructor() {
    super(defaultRailPartOptions);
  }

  protected createRailPart(width: number): RailPart {
    return new RailPart(width, this._options);
  }
}
